import React, { useState } from 'react';
import { dangerToast } from '../../helpers/Toast';

const FileInput = ({
  className,
  onChange,
  format,
  nameInput = 'Edit photo',
  withClass = 'w-full',
  textButton = true,
  validation,
  name,
  children,
}) => {
  const [fileName, setFileName] = useState('');

  const validateFormat = (file) => {
    if (!file) return false;

    if (format === 'pdf') {
      return file.type === 'application/pdf';
    } else if (format === 'img') {
      return (
        file.type === 'image/png' ||
        file.type === 'image/jpeg' ||
        file.type === 'image/jpg'
      );
    } else if (format === 'xml') {
      return file.type === 'text/xml';
    }

    return false;
  };

  const validateSize = (file) => {
    if (!file) return false;
    return file.size <= 1024 * 1024; // 1MB
  };

  const getBase64 = (archivo) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(archivo);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!validateFormat(file)) {
      dangerToast(
        'You can only select files format: ' +
        (format === 'img' ? 'png, jpeg, jpg' : format)
      );
      return;
    }

    if (!validateSize(file)) {
      dangerToast('Files up to 1MB');
      return;
    }

    setFileName(file.name);

    try {
      const base64 = await getBase64(file);
      const fileType = file.type;

      if (validation) {
        validation.setFieldValue('name_file_input', file.name);
        validation.setFieldValue(`${name}_format`, fileType);
        validation.setFieldValue(name, base64);
      }

      if (onChange) {
        onChange({ file, base64, fileType });
      }
    } catch (error) {
      console.error('Error converting file to Base64:', error);
    }
  };

  return (
    <div className={`flex items-center justify-center ${withClass}`}>
      <label className="flex flex-col items-center w-full cursor-pointer group">
        {children ? (
          children
        ) : (
          <span
            className={`
              inline-flex items-center gap-2
              px-5 py-2.5 rounded-full
              bg-cs-primary-soft text-cs-primary
              text-xs font-medium
              border border-cs-primary/20
              shadow-sm
              hover:bg-cs-primary hover:text-white
              active:scale-[0.97]
              transition-all duration-150
              ${className || ''}
            `}
          >
            <span className="material-symbols-outlined text-[16px]">
              upload
            </span>
            {fileName
              ? textButton
                ? fileName
                : nameInput
              : nameInput}
          </span>
        )}

        <input
          type="file"
          className="hidden"
          onChange={handleFileChange}
        />
      </label>

      {fileName && (
        <p className="text-[10px] text-cs-muted mt-1 text-center truncate max-w-[220px]">
          {fileName}
        </p>
      )}
    </div>
  );
};

export default FileInput;
